import { ClientSelection } from 'src/entities/client';

export enum SelectionType {
  AutoDetected,
  ClientAction,
}

export type ClientSelectionWeighted = {
  [key in keyof ClientSelection]: [ClientSelection[key], SelectionType];
};

export type SelectionWithPriority = ClientSelection & { priority: Record<keyof ClientSelection, SelectionType> };
export type ClientSelectionStorage = { setItem: (v: ClientSelectionWeighted) => void; getItem: () => ClientSelectionWeighted | null };

export class ClientSelectionService {
  #storage: ClientSelectionStorage;

  constructor(storage: ClientSelectionStorage) {
    this.#storage = storage;
  }

  register(values: Partial<ClientSelection>, weight: SelectionType = SelectionType.AutoDetected) {
    const existingSelections = this.getSelectionsWithWeight();
    const nextValues = Object.entries(values).reduce((acc, [key, value]) => {
      const existingSelection = acc[key];
      if (!existingSelection || existingSelection[1] <= weight) {
        // @ts-ignore
        acc[key] = [value, weight];
      }
      return acc;
    }, existingSelections);

    this.#storage.setItem({ ...nextValues });
  }

  getSelections(minWeight = SelectionType.AutoDetected): ClientSelection {
    const selections = this.getSelectionsWithWeight();
    return Object.entries(selections).reduce((res, [key, selection]) => {
      // @ts-ignore
      const [value, weight] = selection;
      if (weight >= minWeight) {
        res[key] = value;
      }
      return res;
    }, {} as ClientSelection);
  }

  getSelectionsWithWeight(): ClientSelectionWeighted {
    return this.#storage.getItem() || {};
  }
}
